export default __webpack_public_path__ + "static/media/westfield-direct-service.inline.62ae0a7e.svg";